import { render, staticRenderFns } from "./product_search_list.vue?vue&type=template&id=b5a410a4&scoped=true&"
import script from "./product_search_list.vue?vue&type=script&lang=js&"
export * from "./product_search_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a410a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5a410a4')) {
      api.createRecord('b5a410a4', component.options)
    } else {
      api.reload('b5a410a4', component.options)
    }
    module.hot.accept("./product_search_list.vue?vue&type=template&id=b5a410a4&scoped=true&", function () {
      api.rerender('b5a410a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/modal_list/product_search_list.vue"
export default component.exports